import React from "react";
import DashboardLayout from "../../Layouts/DashboardLayout";
import ChatComp from "./DirectMessage";
import { useLocation } from "react-router";

const ChatContainer = ({id,title}) => {
  // const locatiSon = useLocation();
  // let id = location.state.selectedGroup?.id
  // let title = location.state.selectedGroup?.title
  return (
    <DashboardLayout>
      <ChatComp id={id} title={title} />
    </DashboardLayout>
  );
};

export default ChatContainer;
